import $ from 'jquery';
import * as FastClick from 'fastclick';

const isIOS = () => (
	navigator && navigator.userAgent && navigator.userAgent.match(/iPhone|iPad|iPod/i)
);

const setFastClick = () => {
	if (isIOS()) {
		FastClick.attach(document.body);
	}
};

$(document).ready(() => {
	$('.go-to-top').on('click', () => {
		const DOM = $('html, body');
		DOM.stop().animate({ scrollTop: 0 }, 800, 'swing');
	});
});

$(window).on('load', () => {
	$('body').addClass('load');

	setTimeout(() => {
		$('.loading-block').remove();
	}, 2000);
});

setFastClick();



// WEBPACK FOOTER //
// ./src/js/common.js